import {
	Avatar,
	AVATAR_SHAPE,
	DashboardIcon,
	DROP_MENU_SELECTION_MODE,
	DropMenu,
	DropMenuDivider,
	DropMenuItem,
	HouseIcon,
} from '@sailadv/hdata-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useRoutes } from '@/entities/navigation';
import { useIsPlant } from '@/entities/user';
import { useNamespace } from '@/shared/lib/hooks/use-namespace.hook';

import { FLEET_KEY, SCOPE_SEARCH_MIN_ITEMS } from '../../model/constants/scope-switcher.constant';
import { useUpdateBoatId } from '../../model/utils/hooks/use-update-boat-id.hook';
import { ScopeMenuProps } from './scope-menu.types';

export const ScopeMenu = ({ boats, selectedId = FLEET_KEY }: ScopeMenuProps) => {
	const namespace = useNamespace('common');
	const { t } = useTranslation(namespace as ['plant', 'common'] | 'common');
	const navigate = useNavigate();
	const { multiView, singleView } = useRoutes();
	const isPlant = useIsPlant();
	const updateBoatId = useUpdateBoatId({ redirect: false });

	const handleFleet = () => {
		navigate(multiView);
	};

	const handleBoat = (id: string) => () => {
		updateBoatId(id);
		navigate(singleView);
	};

	return (
		<DropMenu
			aria-label={t('select.boat.empty')}
			selectionMode={DROP_MENU_SELECTION_MODE.SINGLE}
			selectedKeys={[selectedId]}
			search={boats.length >= SCOPE_SEARCH_MIN_ITEMS}
			size="lg"
		>
			<DropMenuItem id={FLEET_KEY} leading={<DashboardIcon />} onAction={handleFleet}>
				{t('common:contextBar.fleet')}
			</DropMenuItem>
			<DropMenuDivider />
			{boats.map(({ id, name, mmsi }) => (
				<DropMenuItem
					key={id}
					id={id}
					leading={isPlant ? <HouseIcon /> : <Avatar shape={AVATAR_SHAPE.SQUARE} size="md" />}
					description={mmsi}
					onAction={handleBoat(id)}
				>
					{name}
				</DropMenuItem>
			))}
		</DropMenu>
	);
};
